export const config = {
  title: 'E&V Painting LLC | Professional Interior & Exterior Painting in Riverside, NJ',
  meta: {
    description:
      'E&V Painting LLC offers expert interior and exterior painting, drywall repair, and residential renovations in Riverside, NJ and surrounding areas. Licensed, insured, and trusted for superior finishes.',
    keywords: [
      'E&V Painting LLC',
      'Painting Services NJ',
      'Interior Painting Riverside',
      'Exterior Painting New Jersey',
      'Drywall Repair',
      'House Painters NJ',
      'Home Renovation',
      'Residential Painting',
      'EddiePro Painting'
    ],
    author: 'E&V Painting LLC',
    canonicalUrl: 'https://www.eddiepro.com/',
  },
  sections: {
    header: {
      businessName: 'E&V Painting LLC',
    },
    sectionB: {
      heroTitle: 'E&V Painting LLC',
      heroSubtitle: 'Professional Painting & Renovation Services in Riverside, NJ',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '6097278826',
      phoneLabel: '(609) 727-8826',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1312114883/photo/mature-painter-painting-a-wall.jpg?s=612x612&w=0&k=20&c=t-afZ_AqE2YBkVrpc2VxAGtFfXpySDYrCOgLznO5cTk=',
      cardData: [
        {
          title: 'Interior & Exterior Painting',
          description: 'Expertly executed painting services using high-quality finishes to beautify your home.',
        },
        {
          title: 'Drywall & Repair',
          description: 'Professional drywall installation, repair, and surface preparation before painting.',
        },
        {
          title: 'Reliable & Timely Service',
          description: 'We’re committed to delivering top-notch service with attention to detail and punctuality.',
        },
      ],
      description:
        'E&V Painting LLC is your go-to for residential and commercial painting, drywall, and renovation projects in Riverside and surrounding areas. We pride ourselves on our clean, professional work and excellent customer communication.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'At E&V Painting LLC, we deliver top-tier craftsmanship in every brushstroke. Explore our full range of services.',
      cards: [
        {
          title: 'Interior Painting',
          description: 'Transform your living space with premium paint and precise application.',
          imageSrc: 'https://media.istockphoto.com/id/968014122/photo/profesional-painter-painting-with-paint-roller.jpg?s=612x612&w=0&k=20&c=vFLGWKW4MMZiIxiM53gs1ZBkh2ceE3iUAYx1ZPMEPfI=',
          imageAlt: 'Interior Painting',
        },
        {
          title: 'Exterior Painting',
          description: 'Protect and enhance your home’s exterior with weather-resistant finishes.',
          imageSrc: 'https://media.istockphoto.com/id/1250041313/photo/asian-painter-hanging-by-rope-for-fixing-and-painting-exterior.jpg?s=612x612&w=0&k=20&c=yaajywWds1VNqTKxuF5nGG64c-tsW2LpC2QHamwuIcs=',
          imageAlt: 'Exterior Painting',
        },
        {
          title: 'Drywall Repair',
          description: 'Patching holes, smoothing surfaces, and prepping for flawless painting results.',
          imageSrc: 'https://media.istockphoto.com/id/1369580172/photo/drywall-sander.jpg?s=612x612&w=0&k=20&c=IMJJL5Qtf96lcsqHAMq5jMTEY6SyLgV3S-p0ZhbKDD4=',
          imageAlt: 'Drywall Repair',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Trim & Baseboard Painting',
        'Power Washing',
        'Deck Staining',
        'Wallpaper Removal',
        'Minor Renovations',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/895802378/photo/male-hand-painting-wall-with-paint-roller-painting-apartment-renovating-with-red-color-paint.jpg?s=612x612&w=0&k=20&c=9DXy75Mzgf-qWjrCZt1DY3IBRIps_4PG9fkyEkBR6dw=',
        alt: 'E&V Painting LLC Team',
      },
      aboutText: [
        'Founded by Eddie K., E&V Painting LLC has been delivering high-quality painting and renovation services throughout New Jersey for over a decade.',
        'Our goal is simple: transform your home or property with beautiful finishes, dependable service, and honest pricing.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'E&V Painting Logo',
      businessName: 'E&V Painting LLC',
      contact: {
        phone: '6097278826',
        phoneLabel: '(609) 727-8826',
        email: 'edykilic@gmail.com',
        website: 'https://www.eddiepro.com/',
        address: '555 Fairview Street, Riverside, NJ 08075, United States',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '555 Fairview Street, Riverside, NJ 08075, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3062.6040171104976!2d-74.9575142846205!3d40.032721279410616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c142c84b99b5d5%3A0x907f187a1a1cb6a0!2s555%20Fairview%20St%2C%20Riverside%2C%20NJ%2008075%2C%20USA!5e0!3m2!1sen!2sus!4v1712201234567!5m2!1sen!2sus',
    },
  },
};

export default config;
